function getAgeOptions(min, max) {
  return new Array(max - min + 1).fill(0).map((x, i) => i + min).map(value => ({
    label: String(value),
    value
  }))
}

module.exports = {
  type: 'form',
  id: 'masterdata',
  icon: 'fad fa-file-alt',
  title: {
    de: 'Stammdaten',
    en: 'Master data'
  },
  intro: require('./Manufacturing-Intro.html'),
  outro: '',
  form: [
    {
      id: 'name',
      type: 'text',
      label: {
        de: 'Auftrags-ID',
        en: 'Order ID'
      },
      info: {
        de: 'Bitte keine Patientendaten eingeben',
        en: 'Please refrain from entering patient information'
      }
    },
    {
      id: 'description',
      type: 'multi',
      label: {
        de: 'Beschreibung',
        en: 'Description'
      }
    },
    // Model
    {
      id: 'itemref',
      type: 'hidden',
      value: 'S.PR.04132',
      defaultValue: 'S.PR.04132'
    },
    {
      id: 'revenueType',
      defaultValue: 'S',
      type: 'hidden'
    },
    {
      id: 'workflow',
      defaultValue: 'Manufacturing',
      type: 'hidden'
    }
  ]
}
